import React, { FC, useEffect, useRef, useState } from "react";
import { getLabelName, isSystemConfigurationModuleEnabled } from "../../utils";
import { CheckBox, InputDatePicker, LoadingBox, SelectBox, TextBox } from "..";
import {
  InputDatePickerTimeDisplayModeEnum,
  ItemConfigurationsResponseModel,
  ItemModel,
  LookupItemModel,
  SystemModulesEnum,
  TextBoxVersionEnum,
  UserConfigurationModel,
} from "../../models";
import { useSupplierAccounts } from "../../hooks";
import { FormikProps } from "formik";

export const ItemDetailsManager: FC<{
  formik: FormikProps<ItemModel>;
  categoryList: LookupItemModel[];
  itemConfigs: ItemConfigurationsResponseModel;
  userConfiguration: UserConfigurationModel;
  categorySelectBoxMultiselectRef: React.RefObject<any>;
}> = ({
  formik,
  categoryList,
  itemConfigs,
  userConfiguration,
  categorySelectBoxMultiselectRef
}) => {
  //#region state
  const [loading, setLoading] = useState(false);
  const { suppliersLoading, storedSuppliers } = useSupplierAccounts();
  const supplierSelectBoxMultiselectRef = useRef<any>();
  //const categorySelectBoxMultiselectRef = useRef<any>();
  //#endregion
  //#region useEffect
  useEffect(() => {
    const updateFieldValue = async () => {
      if (
        categoryList &&
        categoryList.length !== 0 &&
        (!formik.values.Cat_ID || formik.values.Cat_ID === 0)
      ) {
        await formik.setFieldValue("Cat_ID", categoryList[0].value);
      }
    };
    updateFieldValue().then(() => {});
  }, [categoryList]);
    // useEffect(() => {
    //         console.log(`res_x_1_useEffect_${formik.values.TaxValue}_${new Date()}`)
    // },[seed]);
  //#endregion
  //#region html
  return (
    <>
      {loading && <LoadingBox />}
      <div className="row row-cols-1 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 g-md-4 g-sm-4">
        {categoryList?.length > 1 && (
          <SelectBox
            labelName={getLabelName("category")}
            source={categoryList}
            isSingleSelect={true}
            onStatusChange={async (e: any) => {
              await formik.setFieldValue("Cat_ID", e?.value ?? 0);
            }}
            selectedValues={
              formik.values.Cat_ID != null && formik.values.Cat_ID != 0
                ? [formik.values.Cat_ID.toString()]
                : null
            }
            // selectedValues={item == null ? null : [item.Cat_ID.toString()]}
            errorText={formik.errors.Cat_ID}
            multiselectRef={categorySelectBoxMultiselectRef}
          />
        )}
        <TextBox
          labelName={getLabelName("Item Name")}
          inputName="Name"
          errorText={formik.errors.Name}
          inputValue={formik.values.Name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          version={TextBoxVersionEnum.V2}
        />
        <TextBox
          labelName={getLabelName("English Name")}
          inputName="Name_En"
          errorText={formik.errors.Name_En}
          inputValue={formik.values.Name_En}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          version={TextBoxVersionEnum.V2}
          // optimizeTyping={true}
          // resetKey={generateGuid()}
        />
        <TextBox
          labelName={getLabelName("ItemCode")}
          inputName="Code"
          errorText={formik.errors.Code}
          inputValue={formik.values.Code}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {userConfiguration?.companySetting?.ApplyTax && (
          <TextBox
            labelName={getLabelName("txtTaxPercentage")}
            inputName="TaxValue"
            type="number"
            errorText={formik.errors.TaxValue}
            inputValue={formik.values.TaxValue}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        )}
        <TextBox
          labelName={getLabelName("Limit Order")}
          inputName="OrderLimit"
          type="number"
          inputValue={formik.values.OrderLimit}
          onChange={async (e: any) => {
            formik.values.OrderLimit = e.target.value;
            await formik.setFieldValue("OrderLimit", e.target.value);
          }}
        />
        <TextBox
          labelName={getLabelName("Stagnant Period")} //{t("lookup.nameAr")}
          inputName="StagnantPeriod"
          type="number"
          errorText={formik.errors.StagnantPeriod}
          inputValue={formik.values.StagnantPeriod}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />

        <TextBox
          labelName={getLabelName("Display Index")} //{t("lookup.nameAr")}
          inputName="DisplySequence"
          type="number"
          errorText={formik.errors.DisplySequence}
          inputValue={formik.values.DisplySequence}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />

        {userConfiguration?.companySetting?.Is_Company_Authorized_Tobacco && (
          <TextBox
            labelName={getLabelName("Total Tobaco Value")} //{t("lookup.nameAr")}
            inputName="TobaccoTaxPercentage"
            type="number"
            errorText={formik.errors.TobaccoTaxPercentage}
            inputValue={formik.values.TobaccoTaxPercentage}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isReadOnly={!formik.values.IsIncludeTobaccoTax}
          />
        )}
        {itemConfigs.ShowItemSuppleer && (
          <SelectBox
            labelName={getLabelName("Supplier")}
            source={storedSuppliers}
            isSingleSelect={true}
            onStatusChange={async (e: any) => {
              await formik.setFieldValue("Item_Supplier_ID", e?.value ?? 0);
              formik.values.Item_Supplier_ID = e?.value ?? 0;
            }}
            selectedValues={
              formik.values.Item_Supplier_ID != null &&
              formik.values.Item_Supplier_ID != 0
                ? [formik.values.Item_Supplier_ID.toString()]
                : null
            }
            multiselectRef={supplierSelectBoxMultiselectRef}
            isDataLoading={suppliersLoading}
          />
        )}
        {itemConfigs.ShowExpireDate && (
          <CheckBox
            labelName={getLabelName("Use Expiry Date")}
            checked={formik.values.UseExpiryDate}
            inputName="UseExpiryDate"
            onChange={async (e: any) => {
              formik.values.UseExpiryDate = e.target.checked;
              await formik.setFieldValue("UseExpiryDate", e.target.checked);
            }}
            id="UseExpiryDate"
          />
        )}
        {formik.values.UseExpiryDate && (
          <InputDatePicker
            id="datePicker"
            timeMode={InputDatePickerTimeDisplayModeEnum.None}
            selectedDate={formik.values.DateExpiry}
            className="form-control"
            InputLabel={getLabelName("Expiry Date")}
            name={getLabelName("Expiry Date")}
            onChange={async (date: Date) => {
              formik.values.DateExpiry = date;
              await formik.setFieldValue("DateExpiry", date);
            }}
          />
        )}
        {formik.values.UseExpiryDate && (
          <TextBox
            labelName={getLabelName("Expire Day")} //{t("lookup.nameAr")}
            inputName="ExpireDay"
            type="number"
            errorText={formik.errors.ExpireDay}
            inputValue={formik.values.ExpireDay}
            onChange={async (e: any) => {
              formik.values.ItemsInstores[0].DefaultExpiryDays = e.target.value;
              await formik.setFieldValue("ExpireDay", e.target.value);
            }}
            onBlur={formik.handleBlur}
            isReadOnly={!formik.values.UseExpiryDate}
          />
        )}
        {userConfiguration?.companySetting?.Is_Company_Authorized_Tobacco && (
          <div className="px-2">
            <CheckBox
              labelName={getLabelName("Tobacco Tax")}
              checked={formik.values.IsIncludeTobaccoTax}
              inputName="IsIncludeTobaccoTax"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue(
                  "IsIncludeTobaccoTax",
                  !formik.values.IsIncludeTobaccoTax
                );
              }}
              id="IsIncludeTobaccoTax"
            />
          </div>
        )}
        {isSystemConfigurationModuleEnabled(
          userConfiguration.systemModulesConfigurations,
          (p) => p.ID === SystemModulesEnum.Shared_POS_and_Restaurant
        ) && (
          <div className="px-2 ">
            <CheckBox
              labelName={getLabelName("Open Price")}
              checked={formik.values.OpenItem}
              inputName="OpenItem"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue("OpenItem", !formik.values.OpenItem);
              }}
              id="OpenItem"
            />
          </div>
        )}
        {/*{isSystemConfigurationModuleEnabled(*/}
        {/*  userConfiguration.systemModulesConfigurations,*/}
        {/*  (p) => p.ID === SystemModulesEnum.Shared_POS_and_Restaurant*/}
        {/*) && (*/}
        <div className="px-2 ">
          <CheckBox
            labelName={getLabelName("ShowInPOS")}
            checked={formik.values.ShowInPOS}
            className=" justify-content-between border border-secondary p-2 "
            inputName="ShowInPOS"
            onChange={async () => {
              await formik.setFieldValue("ShowInPOS", !formik.values.ShowInPOS);
            }}
            id="ShowInPOS"
          />
        </div>
        {/*)}*/}
        <div className=" px-2 ">
          <CheckBox
            labelName={getLabelName("Is Active")}
            checked={formik.values.ItemsInstores[0].Status}
            className=" justify-content-between border border-secondary p-2 "
            inputName="ItemsInstores[0].Status"
            onChange={async () => {
              await formik.setFieldValue(
                "ItemsInstores[0].Status",
                !formik.values.ItemsInstores[0].Status
              );
            }}
            id="ItemsInstores[0].Status"
          />
        </div>
        <div className="px-2 ">
          <CheckBox
            labelName={getLabelName("chkWithoutBalance")}
            checked={formik.values.WithoutBalance}
            inputName="WithoutBalance"
            className=" justify-content-between border border-secondary p-2 "
            onChange={async () => {
              await formik.setFieldValue(
                "WithoutBalance",
                !formik.values.WithoutBalance
              );
            }}
            id="WithoutBalance"
          />
        </div>

        {itemConfigs.ShowModifiers && (
          <div className="px-2 ">
            <CheckBox
              labelName={getLabelName("Has Modifiers")}
              checked={formik.values.HasModifiers}
              inputName="HasModifiers"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue(
                  "HasModifiers",
                  !formik.values.HasModifiers
                );
              }}
              id="HasModifiers"
            />
          </div>
        )}
        {itemConfigs.ShowproductionItem && (
          <div className="px-2 ">
            <CheckBox
              labelName={getLabelName("Is Production Item")}
              checked={formik.values.IsProduction}
              inputName="IsProduction"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue(
                  "IsProduction",
                  !formik.values.IsProduction
                );
              }}
              id="IsProduction"
            />
          </div>
        )}
        {itemConfigs.ShowGatherItem && (
          <div className="px-2 ">
            <CheckBox
              className=" justify-content-between border border-secondary p-2 "
              labelName={getLabelName("Gather Item")}
              checked={formik.values.GatherItem}
              inputName="GatherItem"
              onChange={async () => {
                await formik.setFieldValue(
                  "GatherItem",
                  !formik.values.GatherItem
                );
              }}
              id="GatherItem"
            />
          </div>
        )}
        {itemConfigs.IsItemVanishConsign && (
          <div className="px-2 ">
            <CheckBox
              labelName={getLabelName("Is Item Vanish Consign")}
              checked={formik.values.IsItemVanishConsign}
              inputName="IsItemVanishConsign"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue(
                  "IsItemVanishConsign",
                  !formik.values.IsItemVanishConsign
                );
              }}
              id="IsItemVanishConsign"
            />
          </div>
        )}
        {itemConfigs.CanConfigureItemUnitsSeparatedInBalance && (
          <div className="px-2 ">
            <CheckBox
              labelName={getLabelName("Is Unis Separate In Balance")}
              checked={formik.values.IsUnisSeparateInBalance}
              inputName="IsUnisSeparateInBalance"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue(
                  "IsUnisSeparateInBalance",
                  !formik.values.IsUnisSeparateInBalance
                );
              }}
              id="IsUnisSeparateInBalance"
            />
          </div>
        )}
        {itemConfigs.CanConfigureItemUnitsDifferentFactor && (
          <div className="px-2 ">
            <CheckBox
              labelName={getLabelName("Item Is Different Factor")}
              checked={formik.values.IsDifferentFactor}
              inputName="IsDifferentFactor"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue(
                  "IsDifferentFactor",
                  !formik.values.IsDifferentFactor
                );
              }}
              id="IsDifferentFactor"
            />
          </div>
        )}
        {itemConfigs.ShowFilterOilOption && (
          <div className="px-2 ">
            <CheckBox
              labelName={getLabelName("Is Oil Service Item")}
              checked={formik.values.Is_Oil_Service}
              inputName="Is_Oil_Service"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue(
                  "Is_Oil_Service",
                  !formik.values.Is_Oil_Service
                );
              }}
              id="Is_Oil_Service"
            />
          </div>
        )}
        {itemConfigs.ShowFilterOilOption && (
          <div className="px-2 ">
            <CheckBox
              labelName={getLabelName("Is Filter Service Item")}
              checked={formik.values.Is_Filter_Service}
              inputName="Is_Filter_Service"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue(
                  "Is_Filter_Service",
                  !formik.values.Is_Filter_Service
                );
              }}
              id="Is_Filter_Service"
            />
          </div>
        )}
        {itemConfigs.CanAddAddationlCost && (
          <div className="px-2 ">
            <CheckBox
              labelName={getLabelName("Can Add Aadational Cost")}
              checked={formik.values.CanAddAddationalCost}
              inputName="CanAddAddationalCost"
              className=" justify-content-between border border-secondary p-2 "
              onChange={async () => {
                await formik.setFieldValue(
                  "CanAddAddationalCost",
                  !formik.values.CanAddAddationalCost
                );
              }}
              id="CanAddAddationalCost"
            />
          </div>
        )}
      </div>
      <div className="row mt-4 row-cols-1 row-cols-xxl-12 row-cols-xl-12 row-cols-lg-12 row-cols-md-12 row-cols-sm-12 g-md-12 g-sm-12">
        <TextBox
          labelName={getLabelName("Notes")} //{t("lookup.nameAr")}
          inputName="Notes"
          type="textarea"
          errorText={formik.errors.Notes}
          inputValue={formik.values.Notes}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          version={TextBoxVersionEnum.V2}
        />
      </div>
    </>
  );
  //#endregion
};
